<template>
  <div class="view-collects">
    <el-card class="card">
      <div slot="header"
           class="clearfix">
        <span>{{$t('menu.xjlx')}}</span>
      </div>
      <div class="btns">
        <el-button type="primary" @click="addPath">{{ $t('menu.tjlx') }}</el-button>
      </div>
      <div class="view-title">
        <span>{{$t('docMgt.name')}}</span>
        <span>{{$t('modelProcess.oper')}}</span>
        <span>{{$t('menu.gn')}}</span>
      </div>
      <div v-if="viewList" class="view-mains">
        <div class="view"
            v-for="(i, index) in viewList"
            :key="index">
            <span>{{i.PathName}}</span>
            <span>
              <el-link :underline="false" icon="el-icon-edit" @click="edit(i)"></el-link>
              <el-link :underline="false" icon="el-icon-delete" @click="deletes(i)"></el-link>
            </span>
            <span>
              <el-link :underline="false" icon="el-icon-video-play" @click="playPath(i)"></el-link>
            </span>
        </div>
      </div>
      <div v-else class="view-nodata">
        <span>{{ $t('docMgt.noData') }}</span>
      </div>
    </el-card>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
export default {
  name: 'wayList',
  data() {
    return {
      viewList: null,
      tableData: null
    }
  },
  watch: {
  },
  created() {
    this.getPathList()
  },
  methods: {
    addPath() {
      this.$store.commit('showPlayPathBth', true)
      this.$store.commit('closeModal', 'wayList')
    },
    playPath(i) {
      window.PlayPathAnimation(i.PathJson)
      this.$store.commit('showPathControl', true)
    },
    edit(i) {
      this.$prompt('请输入新名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\s\S]$/,
        inputErrorMessage: '至少一个字符'
      }).then(({ value }) => {
        this.editView(value, i)
      }).catch(() => {
      })
    },
    getPathList() {
      ApiService.map.getPathList({
        userID:  JSON.parse(localStorage.user).userId,
      }).then(res => {
        if (res.code === 0) {
          this.viewList = res.data
        } else {
          this.viewList = null
        }
      })
    },
    deletes(i) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deletePathData(i)
      }).catch(() => {
      })
    },
    deletePathData(i) {
      ApiService.map.deletePathData({
        ID: i.ID
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getPathList()
        }
      })
    },
    editView(value, i) {
      ApiService.map.updatePathData({
        ID: i.ID,
        PathName: value
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.getPathList()
        }
      })
    },
  }
}
</script>
<style lang="scss">
@import '../../common/css/color.scss';
.view-collects {
  .card {
    width: 350px;
    border: 0;
    .el-card__body {
      padding: 30px 20px;
      .btns {
        display: flex;
        margin-bottom: 15px;
        .el-button {
          padding: 7px 20px;
        }
      }
      .view-title {
        box-sizing: border-box;
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        background: #E1E3E6;
        font-size: 14px;
        color: #626466;
        span {
          text-align: left;
          padding: 0 10px;
          width: 30%;
        }
        span:first-child {
          width: 40%;
        }
      }
      .view-mains {
        display: flex;
        flex-direction: column;
        height: 280px;
        overflow: auto;
        align-content: flex-start;
        .view {
          box-sizing: border-box;
          width: 100%;
          height: 40px;
          line-height: 40px;
          display: flex;
          border-bottom: 1px solid #E1E3E6;
          font-size: 14px;
          color: #333;
          span {
            width: 30%;
            text-align: left;
            padding: 0 10px;
          }
          span:first-child {
            width: 40%;
          }
        }

        &::-webkit-scrollbar {
          width: 2px;
          height: 500px;
          /**/
        }
        &::-webkit-scrollbar-track {
          background: #fff;
          border-radius: 2px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(23, 78, 176, 0.3);
          border-radius: 2px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: #333;
        }
      }

      .view-nodata {
        height: 280px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          width: 50%;
          line-height: 60px;
          color: #909399;
          font-size: 14px;
        }
      }
    }
  }
}
.el-scrollbar__wrap {
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/mind/wayList.vue